import SmallCurrencyIcon from '../../../Trading/common/SmallCurrencyIcon';
import Text from '../../../../atoms/Text';
import Button from '../../../../molecules/Button';
import {
  formatMobileTableData,
  IMobileTableScema,
} from '../../../../helpers/formatters';
import BodyTableMobile from '../../ModalTable/mobile/BodyTable';
import { ITokensTableProps } from '../TokensTable';

const TokensTableMobile = ({
  tokens,
  network,
  onWithdraw,
}: ITokensTableProps) => {
  const schema: IMobileTableScema = {
    row_1: {
      item_1: {
        name: 'Token',
        accessor: 'token',
        parser: (_, { tokenInfo }) => (
          <div className='token_cell'>
            <SmallCurrencyIcon
              network={network!}
              className='img'
              currency={tokenInfo.contract_name}
              contract={tokenInfo.contract_address}
              variant='m'
            />
            <Text size={14} className='text--grey-400'>
              {tokenInfo.contract_ticker_symbol}
            </Text>
          </div>
        ),
        width: 150,
      },
      item_2: {
        name: 'Value',
        accessor: 'quote_rate',
        parser: (_, { tokenInfo }) =>
          tokenInfo.quote_rate ? `$${tokenInfo.quote_rate}` : '',
      },
    },
    row_2: {
      item_1: {
        name: 'Amount',
        accessor: 'balance',
        width: 150,
      },
      item_2: {
        name: 'Actions',
        accessor: 'withdraw',
        parser: (_, { balance, tokenInfo }) =>
          balance > 0 ? (
            <Button
              size='xs'
              variant='secondary'
              action={() =>
                onWithdraw(
                  tokenInfo.contract_address,
                  tokenInfo.contract_decimals,
                  tokenInfo.balance
                )
              }
              text='Withdraw'
            />
          ) : (
            ''
          ),
      },
    },
  };

  const parsedData = formatMobileTableData({
    data: tokens,
    schema,
    getColorForItem: () => 'grey',
  });

  return <BodyTableMobile data={parsedData} schema={schema} />;
};

export default TokensTableMobile;
